export default __webpack_public_path__ + "static/media/software-erp.b105928a.png";